import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import snakeToCamel from "@/utils/SnakeToCamel";

const actions = {
  getInquiryList(context, query) {
    const url = new URL(`${endpoints.LARAVEL_BASE_URL}${endpoints.API.inquiries}`);
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            const payload = {
              rows: snakeToCamel(res.data.rows || []),
              meta: snakeToCamel(res.data.meta || {}),
              stats: snakeToCamel(res.data.stats || { status_breakdown: [] })
            };
            context.commit("setInquiryList", payload);
            resolve(payload);
          }
        })
        .catch(err => reject(err));
    });
  },

  saveInquiry(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("post", `${endpoints.LARAVEL_BASE_URL}${endpoints.API.inquiries}`, payload)
        .then(res => {
          if (res.status === 201) {
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => reject(err));
    });
  },

  fetchInquiry(context, inquiryId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${endpoints.API.inquiries}/${inquiryId}`)
        .then(res => {
          if (res.status === 200) {
            const data = snakeToCamel(res.data);
            context.commit("setInquiry", data);
            resolve(data);
          }
        })
        .catch(err => reject(err));
    });
  },

  updateInquiry(_, { inquiryId, payload }) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("patch", `${endpoints.LARAVEL_BASE_URL}${endpoints.API.inquiries}/${inquiryId}`, payload)
        .then(res => {
          if (res.status === 200) {
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => reject(err));
    });
  },

  updateInquiryStatus(_, { inquiryId, status }) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.inquiries}/${inquiryId}/status`,
          { status }
        )
        .then(res => {
          if (res.status === 200) {
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => reject(err));
    });
  }
};

export default actions;
